import { Settings } from "../../Settings";
import Rand from "../../util/Rand";
import MinedUpgradeCollection from "../upgrade/free/MinedUpgradeCollection";
import Values from "../value/Values";
import BaseAutomation from "./BaseAutomation";

export default class MinedUpgradeAutomation extends BaseAutomation {
    /**
     * @param {GameTime} gameTime
     * @param {MinedUpgradeCollection} minedUpgradeCollection 
     * @param {Values} values 
     */
    constructor(gameTime, minedUpgradeCollection, values) {
        super(gameTime, values.minedAutomationUnlocked, 
            values.minedAutomationRateUpgrades, 
            Settings.automation.baseUpgradeDelayTurns, 
            Settings.automation.turnsPerRateUpgrade);
        
        /**
         * @constant
         * @type {MinedUpgradeCollection}
         */
        this.minedUpgradeCollection = minedUpgradeCollection;
    }

    /**
     * @override
     */
    purchaseUpgrade() {
        const upgrades = this.minedUpgradeCollection.upgrades;
        if (upgrades.length === 0) {
            return;
        }

        const index = Rand.randomInt(upgrades.length);
        const upgrade = upgrades[index];

        if (upgrade && upgrade.isPurchasable()) {
            upgrade.purchase();
            this.minedUpgradeCollection.remove(upgrade);
        }
    }
    
}